export const toFormat = (s: string, ...args: any) => {
    const regExp = /\$(\d+)/gi;
    // match $1 $2 ...
    return s.replace(regExp, (match, index) => {
      return args[index] ?? match;
    });
  };